(() => {
  const initSlider = (slider) => {
    if (!slider || slider.dataset.tfProductSliderReady === 'true') return;

    const track = slider.querySelector('[data-tf-product-slider-track]');
    const prev = slider.querySelector('[data-tf-product-slider-prev]');
    const next = slider.querySelector('[data-tf-product-slider-next]');
    if (!track || !prev || !next) return;

    slider.dataset.tfProductSliderReady = 'true';
    const isLoop = track.dataset.tfProductSliderLoop === 'true';
    let loopOrigin = 0;
    let loopSegment = 0;
    let loopReady = false;

    const trimLoopClones = () => {
      if (!isLoop || track.dataset.tfProductSliderTrimmed === 'true') return;

      const buffer = 5;
      const origin = track.querySelector('[data-tf-product-slider-loop-origin]');
      const after = track.querySelector('[data-tf-product-slider-loop-after]');
      if (!origin || !after) return;

      const children = Array.from(track.children);
      const originIndex = children.indexOf(origin);
      const afterIndex = children.indexOf(after);
      const beforeClones = children.slice(0, originIndex).filter((item) => item.matches('[data-tf-product-slider-loop-clone]'));
      const afterClones = children.slice(afterIndex).filter((item) => item.matches('[data-tf-product-slider-loop-clone]'));

      beforeClones.slice(0, Math.max(0, beforeClones.length - buffer)).forEach((item) => item.remove());
      afterClones.slice(buffer).forEach((item) => item.remove());
      track.dataset.tfProductSliderTrimmed = 'true';
    };

    const measureLoop = () => {
      if (!isLoop) return;
      trimLoopClones();

      const origin = track.querySelector('[data-tf-product-slider-loop-origin]');
      const after = track.querySelector('[data-tf-product-slider-loop-after]');
      if (!origin || !after) return;

      loopOrigin = origin.offsetLeft;
      loopSegment = after.offsetLeft - origin.offsetLeft;

      if (!loopReady && loopSegment > 0) {
        track.scrollLeft = loopOrigin;
        loopReady = true;
      }
    };

    const normalizeLoop = () => {
      if (!isLoop || !loopReady || loopSegment <= 0) return;

      if (track.scrollLeft < loopOrigin - loopSegment * 0.25) {
        track.scrollLeft += loopSegment;
      } else if (track.scrollLeft > loopOrigin + loopSegment * 1.25) {
        track.scrollLeft -= loopSegment;
      }
    };

    const update = () => {
      const isLoading = slider.classList.contains('tf-product-slider--loading');
      if (isLoading) {
        prev.disabled = true;
        next.disabled = true;
        slider.classList.remove('is-scrollable');
        return;
      }

      measureLoop();
      normalizeLoop();

      const maxScroll = track.scrollWidth - track.clientWidth;
      const hasOverflow = maxScroll > 2;

      prev.disabled = !hasOverflow || (!isLoop && track.scrollLeft <= 2);
      next.disabled = !hasOverflow || (!isLoop && track.scrollLeft >= maxScroll - 2);
      slider.classList.toggle('is-scrollable', hasOverflow);
    };

    const move = (direction) => {
      if (slider.classList.contains('tf-product-slider--loading')) return;

      const firstItem = track.querySelector('.tf-product-slider__item');
      const itemWidth = firstItem ? firstItem.getBoundingClientRect().width : track.clientWidth;
      track.scrollBy({ left: direction * Math.min(track.clientWidth, itemWidth * 2), behavior: 'smooth' });
    };

    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', () => {
      loopReady = false;
      update();
    });

    requestAnimationFrame(update);
    setTimeout(update, 350);
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-tf-product-slider]').forEach(initSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches('[data-tf-product-slider]')) {
          initSlider(node);
        } else {
          initAll(node);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
